import {
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import Constants from "data/Constants";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { deliverNotification } from "services/notification.service";
import * as yup from "yup";
import Utils from "../utils/index";

function CustomNotification(props) {
  const { setProgress, setToast } = useOutletContext();

  const data = {
    users: [],
    contentTitle: "",
    contentMessage: "",
    channels: [], // "EMAIL", "SMS", "APP"
    scope: "ALL", // "SINGLE", "MENTEES", "MENTORS", "ADMINS", "ALL"
  };

  const validationSchema = yup.object({
    contentTitle: yup.string().required().label("Title").max(50),
    contentMessage: yup.string().required().label("Message").min(10).max(250),
    channels: yup
      .array()
      .required("Select at least one channel *")
      .label("Channel")
      .min(1, "Select at least one channel *")
      .max(3),
    scope: yup
      .string()
      .required()
      .label("Scope")
      .oneOf(Constants.Notification.Scope),
  });

  const formik = useFormik({
    initialValues: data,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      formSubmitHandler(values);
    },
  });

  const handleCheckBox = (e) => {
    const temp = [...formik.values.channels];
    const index = temp.findIndex((v) => {
      return v == e.target.value;
    });
    if (index == -1) {
      // not in array,
      temp.push(e.target.value);
    } else {
      temp.splice(index, 1);
    }

    formik.setFieldValue("channels", temp);

    if (temp.length == 0) formik.setFieldError("Select at least one channel *");
  };

  const handleDeleteUser = (index) => {
    const temp = [...formik.values.users];
    temp.splice(index, 1);
    formik.setFieldValue("users", temp);
  };

  const formSubmitHandler = async (values) => {
    setProgress(true);

    const body = {
      users: values.users,
      content: {
        title: values.contentTitle,
        message: values.contentMessage,
      },
      channels: values.channels,
      scope: values.scope,
    };

    try {
      const res = await deliverNotification(body);
      setProgress(false);
      formik.resetForm();

      setToast({
        success: true,
        message: "Notifications Delivered",
        autohide: 3000,
      });
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="font-bold col-span-1 my-2">New Notification</div>
      <div className="md:p-5 md:grid-cols-2 grid gap-5">
        <div className="flex flex-col gap-4">
          <TextField
            label="Scope"
            variant="filled"
            size="small"
            name="scope"
            value={formik.values.scope}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.scope && Boolean(formik.errors.scope)}
            helperText={formik.touched.scope && formik.errors.scope}
            required
            select
            fullWidth
          >
            {Constants.Notification.Scope.map((option, index) => {
              return (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              );
            })}
          </TextField>

          <div>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2">
              <h5 className="">Channels * :</h5>
              <div>
                <FormControlLabel
                  value="APP"
                  control={<Checkbox size="small" />}
                  label="App"
                  labelPlacement="start"
                  onChange={handleCheckBox}
                />
                <FormControlLabel
                  value="EMAIL"
                  control={<Checkbox size="small" />}
                  label="Email"
                  labelPlacement="start"
                  onChange={handleCheckBox}
                />
                <FormControlLabel
                  value="SMS"
                  control={<Checkbox size="small" />}
                  label="SMS"
                  labelPlacement="start"
                  onChange={handleCheckBox}
                />
              </div>
            </div>
            <div
              className="text-xsm text-red-700"
              hidden={
                !(formik.touched.channels && Boolean(formik.errors.channels))
              }
            >
              {formik.touched.channels && formik.errors.channels}
            </div>
          </div>
          {formik.values.scope == "SINGLE" && (
            <>
              <TextField
                label="Add New User ID"
                variant="filled"
                size="small"
                required
                fullWidth
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    if (e.target.value) {
                      var temp = [...formik.values.users];
                      if (!temp.includes(e.target.value)) {
                        temp = temp.concat(e.target.value.split(" "));
                        formik.setFieldValue("users", temp);
                        e.target.value = "";
                      }
                    }
                    e.preventDefault();
                  }
                }}
              />

              <div className="flex gap-2 flex-wrap">
                {formik.values.users.map((userId, index) => {
                  return (
                    <Chip
                      label={userId}
                      key={index}
                      onDelete={() => handleDeleteUser(index)}
                    />
                  );
                })}
              </div>
            </>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <TextField
            label="Title"
            variant="filled"
            size="small"
            name="contentTitle"
            value={formik.values.contentTitle}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.contentTitle && Boolean(formik.errors.contentTitle)
            }
            helperText={
              formik.touched.contentTitle && formik.errors.contentTitle
            }
            placeholder="Enter the Title for notification content"
            required
            fullWidth
          />
          <TextField
            label="Message"
            variant="filled"
            size="small"
            name="contentMessage"
            value={formik.values.contentMessage}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.contentMessage &&
              Boolean(formik.errors.contentMessage)
            }
            helperText={
              formik.touched.contentMessage && formik.errors.contentMessage
            }
            placeholder="Enter the body for notification content"
            required
            fullWidth
            multiline
            minRows={4}
          />

          <div className="my-4 text-right">
            <Button
              type="submit"
              variant="contained"
              onClick={formik.handleSubmit}
            >
              Deliver Notification
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default CustomNotification;
